//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import React, { useEffect, useState, useRef, memo } from 'react';
import { connect, useDispatch } from 'react-redux';
import styled from 'styled-components';
import { filter, get } from 'lodash';
import moment from 'moment';
//  -- Components ---------------------
import { Col, Row } from 'antd';
import Loading from 'components/Loading';

//  -- Constants --------------x--------
import COLOR from 'utils/constants/color';

//  -- Thunks -------------------------
import { handleListBubbleClassNotes } from 'store/notes/thunks';
import { handleListClassSubmissions } from 'store/submissions/thunks';
import { handleListClassUsers } from 'store/userClasses/thunks';
import { birdCloude, quoteLeft, quoteRight, userRobert } from "utils/assets/images"
import { getRandomCotation, isBeforTime } from 'utils/methods/math';
import "moment-timezone"
import { useCurrentClassBook } from 'store/classes/selectors';
import { isBookAllowed } from 'utils/lib/ebookHelper';
import { useUserAllowedBooks } from 'store/books/selectors';
import { EyeFilled } from '@ant-design/icons';
import SentryWrap from 'components/Sentry';
import { useUI } from 'store/UI/selectors';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Cell,
  LabelList
} from 'recharts';
import myAssignSvg from "../utils/assets/images/my-assign.svg";
import AdminDashboardClassDataSkeletonPage from 'pages/AdminDashboardClassDataSkeletonPage';
const config = {
  chart: {
    type: 'bar',
    styledMode: false,
    backgroundColor: 'transparent',
    marginRight: 50,
    marginLeft: 120
    // style: {
    //     fontFamily: 'Inter, sans-serif'
    // }
  },
  colors: ['#5E2D7F', '#A42F80', '#16B694', '#29528A', '#669AD3', '#E14692', '#332057', '#F47747'],
  title: {
    text: '',
  },
  accessibility: {
    announceNewData: {
      enabled: true
    }
  },
  xAxis: {
    type: 'category',
    labels: {
      useHTML: true,
      style: {
        color: '#888',
        fontSize: '16px'
      }
    },
    lineColor: '#4D5FFE',  // BLUE line color
    lineWidth: 2,          // Line thickness
    tickWidth: 0
  },
  yAxis: {
    // min: 0,
    // max: 105,
    // tickInterval: 5,
    softMin: 0,
    softMax: 1,
    gridLineColor: '#eee',
    gridLineWidth: 0,
    title: { text: '' },
    labels: {
      style: {
        color: '#61677E',
        fontSize: '12px'
      }
    },
    lineColor: '#4D5FFE',  // BLUE line color
    lineWidth: 2,          // Line thickness
    tickWidth: 1,
    tickColor: '#1C38F5',     // blue tick marks
    tickLength: 8,            // height of tick marks
    tickPosition: 'inside'
  },
  legend: {
    enabled: false
  },
  plotOptions: {
    series: {
      pointPadding: 0.3, // adds vertical spacing between bars
      groupPadding: 0,   // removes group spacing
      pointWidth: 27,    // sets exact bar height
      borderRadius: 8,
      borderWidth: 0,
      dataLabels: {
        enabled: true,
        align: 'left',
        inside: false,
        crop: false, // ensures label is shown even if it would be clipped
        //overflow: 'allow',
        overflow: 'none', // prevents it from hiding
        x: 15, // increased spacing from bar
        style: {
          color: '#2C3E50',
          fontSize: '12px',
          fontWeight: 400,
          letterSpacing: 0.5,
          textShadow: '0 0 3px rgba(255,255,255,0.9)',
        },
      }
    }
  },

  // responsive: {
  //     rules: [{
  //       condition: {
  //         maxWidth: 480
  //       },
  //       chartOptions: {
  //         chart: {
  //           marginRight: 80
  //         },
  //         plotOptions: {
  //           series: {
  //             dataLabels: {
  //               style: {
  //                 fontSize: '10px'
  //               }
  //             }
  //           }
  //         }
  //       }
  //     }]
  //   },

  tooltip: {
    headerFormat: '',
    pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.y}</b>'
  },

  series: [
    {
      name: "",
      colorByPoint: true,
      data: [
        {
          name: "Notes taken",
          y: 0,
          color: {
            linearGradient: { x1: 0, y1: 0, x2: 1, y2: 0 },
            stops: [
              [0, '#5E2D7F'],
              [1, '#5E2D7F']
            ]
          }
        },
        {
          name: "Activities assigned",
          y: 0,
          color: {
            linearGradient: { x1: 0, y1: 0, x2: 1, y2: 0 },
            stops: [
              [0, '#A42F80'],
              [1, '#A42F80']
            ]
          }
        },
        {
          name: "Activities completed",
          y: 0,
          color: {
            linearGradient: { x1: 0, y1: 0, x2: 1, y2: 0 },
            stops: [
              [0, '#16B694'],
              [1, '#16B694']
            ]
          }
        },
        {
          name: "Activities past due",
          y: 0,
          color: {
            linearGradient: { x1: 0, y1: 0, x2: 1, y2: 0 },
            stops: [
              [0, '#29528A'],
              [1, '#29528A']
            ]
          }
        },
        {
          name: "Quizzes Assigned",
          y: 0,
          color: {
            linearGradient: { x1: 0, y1: 0, x2: 1, y2: 0 },
            stops: [
              [0, '#669AD3'],
              [1, '#669AD3']
            ]
          }
        },
        {
          name: "Quizzes completed",
          y: 0,
          color: {
            linearGradient: { x1: 0, y1: 0, x2: 1, y2: 0 },
            stops: [
              [0, '#E14692'],
              [1, '#E14692']
            ]
          }
        },
        {
          name: "Quizzes past due",
          y: 0,
          color: {
            linearGradient: { x1: 0, y1: 0, x2: 1, y2: 0 },
            stops: [
              [0, '#332057'],
              [1, '#332057']
            ]
          }
        }
      ]
    }
  ]


}


//  ----------------------------------------------------------------------------
//  Styles
//  ----------------------------------------------------------------------------

const Wrapper = styled.div`
    height: auto;
    margin-bottom: 80px;
    width: 100%;
`;
const SettingIcon = styled.img`
    display: block;
    margin-left: auto;
    margin-right: auto;
    width: 100%;
    margin-top: -20px;
`;
const Box = styled.div`
    -webkit-box-shadow: -2px 0px 7px 0px rgba(163,150,150,0.48);
    -moz-box-shadow: -2px 0px 7px 0px rgba(163,150,150,0.48);
    box-shadow: -2px 0px 7px 0px rgba(163,150,150,0.48);
    height: 350px;
    width:250px;
    border-radius: 10px;
    background-image: linear-gradient(to bottom,${COLOR.indigo300} ,${COLOR.indigo600},${COLOR.indigo200},${COLOR.indigo100},${COLOR.indigo500});
`;

const NoteTitle = styled.div`
    font-size: 18px;
    font-weight: 600;
    margin-left: 10px;
    color: white;
    padding-top: 10px;
    text-transform: uppercase;
    white-space: pre-line;
    line-height: 20px;
`;
const NoteText = styled.div`
    font-size: 28px;
    text-align: center;
    font-weight: bold;
    color: white;
    margin-left: auto;
`
const ContentWrapper = styled.div`
height:${p => p.height ? p.height : "30%"};
`
const NoDataImg = styled.img`
  width: 100%;
  height: 80%;
  object-fit: fill;
  `
//  ----------------------------------------------------------------------------
//  Component
//  ----------------------------------------------------------------------------
//
//  Admin class visuals
//
//  -- Description
//  Admin view class visuals
//
//  -- Props
//  ...
//
//  -- State
//  ...
//
//  -- Methods
//  ...
//
//  -- Usage
//


const ProgressCardItem = memo(({ 
  title,
  programType,
  value,
  max,
}) => {
  const [size, setSize] = useState(135);
  const [sizeIner, setSizeIner] = useState(110);
  const [fontSize, setFontSize] = useState(35); // default font size
  const [fontSizeIner, setFontSizeIner] = useState(26);

  useEffect(() => {

    const updateDimensions = () => {
      const width = window.innerWidth;
  
      if (width <= 480) {
        // Mobile
        setSize(100);
        setSizeIner(90);
        setFontSize(22);
        setFontSizeIner(20);
      } else if (width >= 1200) {
        // Desktop
        setSize(110);
        setSizeIner(90);
        setFontSize(28);
        setFontSizeIner(26);
      } else {
        // Tablet or mid-size screen
        setSize(135);
        setSizeIner(110);
        setFontSize(35);
        setFontSizeIner(24);
      }
    };

    updateDimensions(); // on mount
    window.addEventListener('resize', updateDimensions);
    return () => window.removeEventListener('resize', updateDimensions);
  }, [window.innerWidth]);

  const pct = max && max > 0 ? Math.round((value / max) * 100) : 0;
  const strokeWidth = 10;

  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (pct / 100) * circumference;


  return (
    <div className={`adminPrgrsInfo ${programType === "student-count" ? "studentCountUpr" : ""}`}>
        {programType === "student-count" ? (
          <>
            <label>{title}</label>
            <div className='cardAlignCenter'>
              <p>{value}</p>
              <img src={userRobert} style={{ width: 'auto', height: size }} />
            </div>
          </>
        )     
        : (
          <>
            <label>{title}</label>
            <div className='cardAlignCenter'>
            <p>{value}</p>
            <svg width={size} height={size}>
              <defs>
                <linearGradient id="progressGradient" x1="225" y1="114" x2="0" y2="114" gradientUnits="userSpaceOnUse">
                  <stop stop-color="#4D5FFE" />
                  <stop offset="1" stop-color="#F75CFA" />
                </linearGradient>
              </defs>
              <circle
                cx={size / 2}
                cy={size / 2}
                r={radius}
                stroke="#f3f3fa"
                strokeWidth={strokeWidth}
                fill="none"
              />
              <circle
                cx={size / 2}
                cy={size / 2}
                r={radius}
                stroke="url(#progressGradient)"
                strokeWidth={strokeWidth}
                fill="none"
                strokeDasharray={circumference}
                strokeDashoffset={offset}
                strokeLinecap="round"
                style={{ transition: 'stroke-dashoffset 0.5s' }}
              />
              <text
                x="50%"
                y="54%"
                textAnchor="middle"
                dominantBaseline="middle"
                style={{
                  fontSize:fontSizeIner 
                }}
                fontWeight="bold"
                fill="#111"
              >
                {pct}%
              </text>
            </svg>
            </div>
          </>
        )}
    </div>
  );
});

const MemoizedBarChart = memo(({ chartData }) => (
  <BarChart className='barChart barchartResponsivenessHeight '
    width={700}
    height={350}
    data={chartData}
    layout="vertical"
    margin={{ right: 25, left: 5 }}
  >
    <CartesianGrid strokeDasharray="4 4" horizontal={false} opacity={0.1} />
    <XAxis type="number" 
      tick={{ fill: '#61677E', fontSize: 12 }}
      axisLine={{ stroke: '#4D5FFE', strokeWidth: 2 }}
      tickLine={false}
      domain={[0, dataMax => Math.ceil(dataMax / 3) * 3 + 20]}
    />
    <YAxis
      dataKey="name"
      type="category"
      axisLine={{ stroke: '#4D5FFE', strokeWidth: 2 }}
      tickLine={false}
      width={150}
      tick={({ x, y, payload }) => (
        <text
          x={x - 5}
          y={y}
          dy={4}
          textAnchor="end"
          fill="#61677E"
          fontSize={10}
          style={{ whiteSpace: "nowrap" }}
        >
          {payload.value}
        </text>
      )}
    />
    <Tooltip cursor={false} formatter={(val) => [val, 'Count']} />
    <Bar dataKey="value" radius={[0, 8, 8, 0]}>
      <LabelList
        dataKey="value"
        position="right"
        offset={2}
        style={{
          fill: '#2C3E50',
          fontSize: 12,
          fontWeight: 400,
          textShadow: '0 0 3px rgba(255,255,255,0.9)',
        }}
      />
      {chartData.map((entry, index) => (
        <Cell key={`cell-${index}`} fill={entry.fill} />
      ))}
    </Bar>
  </BarChart>
));

const AdminVisuals = ({
  classActivities,
  classNotes,
  classQuizzes,
  classUsers,
  currentClass,
  submissions,
}) => {
  const dispatch = useDispatch();
  // const timezone = useOrgTimezone();
  const userAllowedBooks = useUserAllowedBooks();
  const [loading, setLoading] = useState(true);
  const [quotation, setQuotation] = useState(getRandomCotation());
  // const [pastDueActivityCount, setPastDueActivityCount] = useState(0);
  // const [completedActivityCount, setCompletedActivityCount] = useState(0);
  // const [ActivityCstm, setActivityCstm] = useState(0);
  // const [hasNoData, setHasNoData] = useState(true);
  // const orgPermissions = useCurrentOrgPermission()
  const allowed_books = useCurrentClassBook();
  const [showChart, setShowChart] = useState(true);
  const [activityInfo, setActivityInfo] = useState({
    activityAssigned: 0,
    activityCompleted: 0,
    pastDueActivity: 0,
  })
  const [examinInfo, setExaminInfo] = useState({
    examinAssigned: 0,
    examinCompleted: 0,
    pastDueExamin: 0,
  })
  const [unitExaminInfo, setUnitExaminInfo] = useState({
    unitExaminAssigned: 0,
    unitExaminCompleted: 0,
    pastDueUnitExamin: 0,
  })
  const [chartData, setChartData] = useState([]);
  const { quotesData = [] } = useUI();
  useEffect(() => {
    async function fetchData() {
      setLoading(true);
      let adminVisualClassId = localStorage.getItem("adminVisualClassId")
      if ((adminVisualClassId && adminVisualClassId == currentClass?.id) || (!currentClass?.id && adminVisualClassId === "noclasssid")) {
        setLoading(false);
      }
      await Promise.allSettled([
        dispatch(handleListClassSubmissions(currentClass.id)),
        dispatch(handleListBubbleClassNotes(currentClass.id))
      ])

      localStorage.setItem("adminVisualClassId", currentClass?.id ?? "noclasssid")
      setLoading(false);
      dispatch(handleListClassUsers(currentClass.id));
    }
    fetchData();
  }, [currentClass, dispatch])
  useEffect(() => {
    setQuotation(getRandomCotation())
  }, [])
  const allBarGrafRef = useRef(null);

  useEffect(()=>{
    const all_class_assignment = [...classQuizzes, ...classActivities].filter(k=> k? isBookAllowed(userAllowedBooks?.other_permissions?.resourses, k, k?.type, allowed_books):false);
    const examin_assignment = all_class_assignment.filter(k=> k?.data?.is_exam);
    const unit_examin_assignment = all_class_assignment.filter(k=> k?.data?.is_unit_exam);
    const activity_assignment = all_class_assignment.filter(k=> !k?.data?.is_unit_exam&&!k?.data?.is_exam);
    const activeUser = filter(classUsers, k => get(k, "role") == 'student' && get(k, "active", true)).map(k=>k?.id);
    const numberOfUser = activeUser.length
    let examinAssigned = examin_assignment?.length * numberOfUser;
    let unitExaminAssigned = unit_examin_assignment?.length * numberOfUser;
    let activityAssigned = activity_assignment?.length * numberOfUser;
    let activityCompleted = 0;
    let pastDueActivity = 0;
    let examinCompleted = 0;
    let pastDueExamin = 0;
    let unitExaminCompleted = 0;
    let pastDueUnitExamin = 0;
    const noteTaken = classNotes?.length || 0;
    activity_assignment.forEach(k=>{
      const completed = filter(submissions, x => (x?.assignmentId == k?.activityId || x.assignmentId == k?.quizId) && x?.complete&&activeUser.includes(x?.user?.id)).length;
      activityCompleted+=completed;
      if(isBeforTime(get(k, "dueDate")) && (!k.lateDate || isBeforTime(get(k, "lateDate")))){
        pastDueActivity += numberOfUser-completed;
      }
    })
    examin_assignment.forEach(k=>{
      const completed = filter(submissions, x => (x?.assignmentId == k?.activityId || x.assignmentId == k?.quizId) && x?.complete&&activeUser.includes(x?.user?.id)).length;
      examinCompleted+=completed;
      if(isBeforTime(get(k, "dueDate")) && (!k.lateDate || isBeforTime(get(k, "lateDate")))){
        pastDueExamin += numberOfUser-completed;
      }
    })
    unit_examin_assignment.forEach(k=>{
      const completed = filter(submissions, x => (x?.assignmentId == k?.activityId || x.assignmentId == k?.quizId) && x?.complete&&activeUser.includes(x?.user?.id)).length;
      unitExaminCompleted+=completed;
      if(isBeforTime(get(k, "dueDate")) && (!k.lateDate || isBeforTime(get(k, "lateDate")))){
        pastDueUnitExamin += numberOfUser-completed;
      }
    })
    setActivityInfo({
      activityAssigned: activityAssigned,
      activityCompleted: activityCompleted,
      pastDueActivity: pastDueActivity,
    })
    setExaminInfo({
      examinAssigned: examinAssigned,
      examinCompleted: examinCompleted,
      pastDueExamin: pastDueExamin,
    })
    setUnitExaminInfo({
      unitExaminAssigned: unitExaminAssigned,
      unitExaminCompleted: unitExaminCompleted,
      pastDueUnitExamin: pastDueUnitExamin,
    })
    const barData = [
      { name: "Notes taken", value: noteTaken, fill: '#4D5FFE' },
      { name: "Activities assigned", value: activityAssigned, fill: '#A42F80' },
      { name: "Activities completed", value: activityCompleted, fill: '#16B694' },
      { name: "Activities past due", value: pastDueActivity, fill: '#29528A' },
      { name: "Examen assigned", value: examinAssigned, fill: '#669AD3' },
      { name: "Examen completed", value: examinCompleted, fill: '#E14692' },
      { name: "Examen past due", value: pastDueExamin, fill: '#332057' },
      { name: "Unit Exam assigned", value: unitExaminAssigned, fill: '#F47747' },
      { name: "Unit Exam completed", value: unitExaminCompleted, fill: '#5E2D7F' },
      { name: "Unit Exam past due", value: pastDueUnitExamin, fill: '#A259FF' }
    ];

    setChartData(barData);
  }, [classUsers, classQuizzes, classActivities, submissions, userAllowedBooks, allowed_books, classNotes]);
 useEffect(() => {
        setQuotation(getRandomCotation(quotesData))
    }, [])
  // useEffect(() => {
  //   let pastDueQizlength = 0;
  //   let pastDueActivitylength = 0;
  //   const filteredQuizzes = filter(classQuizzes, k => {
  //     const type = get(k, "type", "");
  //     return isBookAllowed(userAllowedBooks?.other_permissions?.resourses, k, type, allowed_books);
  //   })
  //   const filteredActivities = filter(classActivities, k => {
  //     const type = get(k, "type", "");
  //     return isBookAllowed(userAllowedBooks?.other_permissions?.resourses, k, type, allowed_books);
  //   })
  //   const filteredSubmissions = filter(submissions, k => {
  //     if (!get(k, "user.active", true)) {
  //       return false
  //     }
  //     const type = get(k, "type", "");
  //     return isBookAllowed(userAllowedBooks?.other_permissions?.resourses, k, type, allowed_books);
  //   })
  //   const numberOfUser = filter(classUsers, k => get(k, "role") == 'student' && get(k, "active", true)).length
  //   const quizAssigned = filteredQuizzes?.length * numberOfUser;
  //   const activityAssigned = filteredActivities?.length * numberOfUser
  //   // setHasNoData(filteredQuizzes?.length == 0 && filteredActivities?.length == 0)
  //   const { activity, quiz } = groupBy(filteredSubmissions, 'assignmentType')
  //   const groupedActivityByAssignmentId = groupBy(activity, 'assignmentId');
  //   const groupedQuizByAssignmentId = groupBy(quiz, 'assignmentId');
  //   const quizCompleted = filter(quiz, ["complete", true]).length;
  //   const activityCompleted = filter(activity, ["complete", true]).length;
  //   const pastDueQuiz = filter(filteredQuizzes, x => isBeforTime(get(x, "dueDate")) && (!x.lateDate || isBeforTime(get(x, "lateDate"))));
  //   const pastDueActivity = filter(filteredActivities, x => isBeforTime(get(x, "dueDate")) && (!x.lateDate || isBeforTime(get(x, "lateDate"))));
  //   map(pastDueQuiz, x => {
  //     let numberOfAttempted = groupedQuizByAssignmentId[x.quizId]?.length ?? 0;
  //     let remaining = numberOfUser - numberOfAttempted;
  //     pastDueQizlength += Math.abs(remaining);
  //   })
  //   map(pastDueActivity, x => {
  //     let numberOfAttempted = groupedActivityByAssignmentId[x.activityId]?.length ?? 0;
  //     let remaining = numberOfUser - numberOfAttempted;
  //     pastDueActivitylength += remaining;
  //   })
  //   // setPastDueActivityCount(pastDueActivitylength+pastDueQizlength)
  //   // setCompletedActivityCount(activityCompleted+quizCompleted)
  //   // setActivityCstm(activityAssigned+quizAssigned)
   

  // }, [classUsers, classQuizzes, classActivities, submissions, orgPermissions])

  return (
  <SentryWrap>
    <Wrapper>
      {loading ? (
        <AdminDashboardClassDataSkeletonPage />
      ) : (<>

        <div className='toggleChartUpr'>
          {/* Hide Chart Button */}
          {showChart && (
            <div className="toggleChart toggleChartHide" onClick={() => setShowChart(false)}>
              <span>Hide chart</span>
              <img src={myAssignSvg} alt="" />
            </div>
          )}

          {/* Show Chart Button */}
          {!showChart && (
            <div className="toggleChart toggleChartShow" onClick={() => setShowChart(true)}>
              <span>View chart</span>
              <EyeFilled style={{ fontSize: 22, cursor: "pointer" }} />
            </div>
          )}
        </div>

        {/* Chart Section */}
        {showChart && (
          <Row
              gutter={[
                { xs: 10, sm: 10, md: 10, lg: 10, xl: 25 }, // horizontal gutter
                { xs: 10, sm: 10, md: 10, lg: 10, xl: 25 }, // vertical gutter
              ]}
             className='adminVsulRow'>

            <Col xs={12} sm={12} md={8}  xl={3} className='studentCountCol'>
              <ProgressCardItem
                title={<>Student<br />Count</>}
                programType={"student-count"}
                value={classUsers?.length === 0 ? 0 : filter(classUsers, ["active", true]).length - 1}
                max={100}
              />
            </Col>

            <Col xs={12} sm={12} md={8}  xl={3}>
                <ProgressCardItem
                  title={<>Completed<br />Activities</>}
                  programType={"completed-quizzes-activities"}
                  value={activityInfo.activityCompleted}
                  max={activityInfo.activityAssigned}
                />
            </Col>

            <Col xs={12} sm={12} md={8}  xl={3}>
              <ProgressCardItem
                title={<>Past due<br />Activities</>}
                 programType={"past-due-quizzes-activities"}
                 value={activityInfo.pastDueActivity}
                 max={activityInfo.activityAssigned}
                 
              />
            </Col>

            <Col xs={12} sm={12} md={8}  xl={3}>
              <ProgressCardItem
                title={<>Examen<br />Completed</>}
                value={examinInfo.examinCompleted}
                max={examinInfo.examinAssigned}
              />
            </Col>

            <Col xs={12} sm={12} md={8}  xl={3}>
              <ProgressCardItem
                title={<>Examen <br/> Past due</>}
                value={examinInfo.pastDueExamin}
                max={examinInfo.examinAssigned}
              />
            </Col>

            <Col xs={12} sm={12} md={8}  xl={3}>
              <ProgressCardItem
                title={<>Unit Examen<br/>Completed</>}
                value={unitExaminInfo.unitExaminCompleted}
                max={unitExaminInfo.unitExaminAssigned}
              />
            </Col>

            <Col xs={12} sm={12} md={8}  xl={3}>
              <ProgressCardItem
                title={<>Unit Examen<br/>Past due</>}
                value={unitExaminInfo.pastDueUnitExamin}
                max={unitExaminInfo.unitExaminAssigned}
              />
            </Col>
          </Row>
        )}

        <Row className='graphApplyUpr' gutter={[16, 16]}>
          <Col xs={{ span: 24 }} lg={{ span: 14 }}>
            <div className='graphChart'>
            <MemoizedBarChart chartData={chartData} />
            </div>
          </Col>
          <Col xs={{ span: 24 }} lg={{ span: 10 }}>
            <div className='classDataQuoteUpr'>
              <div className='classDataQuote'>
                <div className='classQuoteLbl'>
                  <p><img src={quoteLeft} className='classQuoteImgLft' />{quotation.message}<img src={quoteRight} className='classQuoteImgRght' /></p>
                  <label>-{quotation.author}</label>
                </div>
                <h3>{moment().format('MMMM, Do YYYY')}</h3>
              </div>
              <div className='birdCloudeUpr'>
                <img src={birdCloude} />
              </div>
            </div>
          </Col>

        </Row>
      </>)}
    </Wrapper>
  </SentryWrap>
  );
};



//  ----------------------------------------------------------------------------
//  Redux
//  ----------------------------------------------------------------------------
const mapStateToProps = state => ({
  classActivities: state.classActivities,
  classNotes: state.classNotes,
  classQuizzes: state.classQuizzes,
  classUsers: state.classUsers,
  currentClass: state.currentClass,
  submissions: state.submissions,
});

export default connect(mapStateToProps, null)(AdminVisuals);
